export const routes = (prefix) => [
    {
        path: `/${prefix}/request-items`,
        name: `${prefix}.request-items.index`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.request-items.index`,
                PageDescription: `Loan Items: Request Items`,
            },
        },
    },
    {
        path: `/${prefix}/request-items/create`,
        name: `${prefix}.request-items.create`,
        component: () => import('./Form.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.request-items.create`,
                PageDescription: `Loan Items: Make Item Request`,
            },
        },
    },
];
